import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './adminLayout.css';

const renderAdminBrand = () => (
  <>
    SO<span className="admin-shell__brand-accent">A</span>L
    <span className="admin-shell__brand-accent">I</span>VE
  </>
);

function AdminLayout({ title, subtitle, children, activeKey, admin, onLogout }) {
  const user = admin && admin.user;
  const isSuperAdmin = user && user.type === 'superadmin';
  const navItems = [
    { key: 'dashboard', label: 'Dashboard', to: '/admin' },
    { key: 'customers', label: 'Customers', to: '/admin/customers' },
    { key: 'templates', label: 'Templates', to: '/admin/templates' },
    { key: 'products', label: 'Products', to: '/admin/products' },
    { key: 'support', label: 'Support Requests', to: '/admin/support' },
    ...(isSuperAdmin ? [{ key: 'admins', label: 'Admin Accounts', to: '/admin/admins' }] : []),
  ];

  return (
    <div className="admin-shell">
      <aside className="admin-shell__nav">
        <div className="admin-shell__logo">
          {renderAdminBrand()}
        </div>
        <nav className="admin-shell__menu">
          <span className="admin-shell__section">Navigation</span>
          {navItems.map((item) => (
            <NavLink
              key={item.key}
              to={item.to}
              exact={item.key === 'dashboard'}
              className="admin-shell__menu-item"
              activeClassName="admin-shell__menu-item--active"
              isActive={(match, location) => {
                if (!match) return activeKey === item.key;
                return true;
              }}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-shell__footer">
          © {new Date().getFullYear()} {renderAdminBrand()}
        </div>
      </aside>
      <main className="admin-shell__main">
        <header className="admin-shell__header">
          <div>
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>}
          </div>
          {user && (
            <div className="admin-shell__actions">
              <div className="admin-shell__user">
                <span className="admin-shell__user-name">{user.name || user.email}</span>
                <span className="admin-shell__user-role">
                  {isSuperAdmin ? 'Superadmin' : user.type === 'viewer' ? 'Viewer' : 'Admin'}
                </span>
              </div>
              <button
                type="button"
                className="admin-shell__logout"
                onClick={onLogout}
              >
                Log out
              </button>
            </div>
          )}
        </header>
        <section className="admin-shell__content">
          {children}
        </section>
      </main>
    </div>
  );
}

AdminLayout.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  activeKey: PropTypes.string,
  admin: PropTypes.shape({
    user: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      type: PropTypes.string,
    }),
  }),
  onLogout: PropTypes.func,
};

AdminLayout.defaultProps = {
  subtitle: null,
  children: null,
  activeKey: 'dashboard',
  admin: null,
  onLogout: undefined,
};

export default AdminLayout;
